var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
// components
import { AccordionBody } from "../accordionbody";
import { AccordionTitle } from "../accordiontitle";
const DEFAULT_TITLE_MARGIN = { left: "0", right: "0" };
export const AccordionItem = (_a) => {
    var { title, content, children, stylingType, opened = false, fontSize, titleBold, onTitleClick, onChange, titleMargin, tag } = _a, props = __rest(_a, ["title", "content", "children", "stylingType", "opened", "fontSize", "titleBold", "onTitleClick", "onChange", "titleMargin", "tag"]);
    const [isOpened, setIsOpened] = useState(opened);
    const accordionRef = useRef(null);
    const customTitleMargin = Object.assign(Object.assign({}, DEFAULT_TITLE_MARGIN), titleMargin);
    useEffect(() => {
        if (opened !== isOpened)
            setIsOpened(opened);
    }, [opened]);
    useEffect(() => {
        if (typeof onChange === "function")
            onChange(isOpened);
    }, [isOpened]);
    const toggle = (o) => !o;
    return (_jsxs("div", Object.assign({}, props, { ref: accordionRef }, { children: [_jsx(AccordionTitle, { title: title, iconAlignment: props.iconAlignment, titlePreviewId: props.titlePreviewId, stylingType: stylingType, opened: isOpened, onTitleClick: (e) => {
                    if (typeof onTitleClick === "function")
                        onTitleClick(e);
                    setIsOpened(toggle);
                }, titleBold: titleBold, fontSize: fontSize, titleMargin: customTitleMargin, tag: tag }), _jsx(AccordionBody, Object.assign({ iconAlignment: props.iconAlignment, contentPreviewId: props.contentPreviewId, stylingType: stylingType, opened: isOpened, fontSize: fontSize }, { children: content || children }))] })));
};
